import api from "./Api";

class PedidoAnexoService {
  GetPedidoAnexo(payload) {
    return api.get("/v1/pedidoAnexo/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoAnexo(payload) {
    return api.post("/v1/pedidoAnexo/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoAnexo(payload) {
    return api.put("/v1/pedidoAnexo/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoAnexo(payload) {
    return api.delete("/v1/pedidoAnexo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoAnexoOData(payload) {
    return api.get("/OData/PedidoAnexo" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PedidoAnexoService();
